// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"tab-nav-module--tab-nav--25zE2","tabCell":"tab-nav-module--tab-cell--R0BSv"};